/**
 * Quantity Selector Web Component
 * Handles +/- button clicks with min value enforcement.
 * Dispatches change event for form integration.
 */
import { ABBaseComponent, defineComponent } from './ab-base-component.js';

class ABQuantitySelector extends ABBaseComponent {
  connectedCallback() {
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const button = event.target.closest('[data-action]');
    if (!button) return;

    const input = this.$('input[name="quantity"]');
    if (!input) return;

    const currentValue = parseInt(input.value, 10) || 1;
    const min = parseInt(input.min, 10) || 1;

    if (button.dataset.action === 'decrease') {
      input.value = Math.max(min, currentValue - 1);
    } else if (button.dataset.action === 'increase') {
      input.value = currentValue + 1;
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

defineComponent('ab-quantity-selector', ABQuantitySelector);
